import React, { Fragment } from 'react'

import { Grid } from '@material-ui/core'

import InputGroup from '../../../../../../UI/Forms/InputGroup/InputGroup'

const AdditionalForm = ({ additionalForm, additionalFormInputChanged }) => {
  const formDisplay = Object.entries(additionalForm).map(formControl => {
    const [formKey, formAttrs] = formControl
    return (
      <Grid key={formKey} item xs={12} lg={3}>
        <InputGroup
          label={formAttrs.label}
          inputType={formAttrs.elementType}
          configs={formAttrs.elementConfig}
          invalid={!formAttrs.valid}
          validations={formAttrs.validation}
          touched={formAttrs.touched}
          changed={e => additionalFormInputChanged(formKey, e)}
          inputValue={formAttrs.value}
          validationError={formAttrs.error}
        />
      </Grid>
    )
  })

  return <Fragment>{formDisplay}</Fragment>
}

export default AdditionalForm
